<template>

  <div class="summary-section date-time-section">
    <header class="section-header">
      <h1>Terminübersicht</h1>
    </header>
    <div class="date-time-info">
      <div class="date-card">
        <div class="date-icon">📅</div>
        <div class="date-text">
          <p><strong>Datum:</strong> {{ formattedDate.date || 'Nicht angegeben' }}</p>
          <p><strong>Uhrzeit:</strong> {{ formattedDate.time || 'Nicht angegeben' }}</p>
        </div>
      </div>
      <div class="time-duration">
        <div class="time-duration-icon">⏳</div>
        <div class="time-duration-text">
          <p><strong>Dauer:</strong> {{ selectedDateTime?.duration ? selectedDateTime.duration + ' Minuten' : 'Nicht angegeben' }}</p>
        </div>
      </div>
      <div class="type">
        <div class="type-icon">🗣️</div>
        <div class="type-text">
          <p><strong>Typ:</strong> {{ selectedType || 'Nicht angegeben' }}</p>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "SubmitAppointmentForm",
  props: {
    identityInfo: {
      type: Object,
      required: true
    },
    selectedDateTime: {
      type: Object,
      default: () => ({})
    },
    selectedType: {
      type: String,
      default: () => ('')
    },
    worker: {
      type: Object,
      required: false
    }
  },
  computed: {
    formattedDate() {
      if (!this.selectedDateTime?.date) return { date: '', time: '' };
      const date = new Date(this.selectedDateTime.date);
      return {
        date: date.toLocaleDateString('de-DE'),
        time: date.toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' })
      };
    }
  }
};
</script>

<style scoped>


.summary-section {
  padding: 1.2em;
  background-color: #f9f9f9;
  border-radius: 0.8em;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #ddd;
}

.date-time-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1em;
}

.section-header {
  width: 100%;
  padding: 0.8em;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  color: #000000;
  border-radius: 0.6em;
  text-align: center;
  margin-bottom: 1em;
}

.section-header h1 {
  margin: 0;
  font-size: 1.4em;
}

.date-time-info {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1em;
}

.date-card, .time-duration, .type {
  display: flex;
  align-items: center;
  padding: 1em;
  border-radius: 0.6em;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
}



.date-icon, .time-duration-icon, .type-icon {
  font-size: 28px;
  margin-right: 1em;
}

.date-text, .time-duration-text, .type-text {
  font-size: 16px;
}

p {
  margin: 0.6em 0;
  font-size: 16px;
  color: #333;
}

strong {
  font-weight: 700;
  color: #333;
}


@media (max-width: 600px) {
  .summary-section{
    padding: 10px;
  }


}


</style>
